export var spacing = {
    xs: '4px',
    s: '8px',
    m: '16px',
    l: '24px',
    xl: '36px',
    xxl: '48px',
};
